import {createSelector} from "@reduxjs/toolkit";

export function selectDoubleFlat(key) {
  return createSelector(s => s[key], x => (x) ? Object.values(x).map(y => Object.values(y)).flat() : null);
};
